import { render, staticRenderFns } from "./SystemLink.vue?vue&type=template&id=07d7c9ce&"
import script from "./SystemLink.vue?vue&type=script&lang=ts&"
export * from "./SystemLink.vue?vue&type=script&lang=ts&"
import style0 from "./SystemLink.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports